module.exports = __webpack_public_path__ + "img/daka.23b08291.png";